import React from "@platform/react";
import { Component, getClassName } from "@platform/react-storybook/Component";

import { Card } from "..";
import { Text } from "../../Text";

import Rules from "./_rules.module.scss";
import { DEF_CHALLENGES_CARD, NAME_CHALLENGES_CARD, TYPE_CHALLENGES_CARD } from "./types";
import type { PropTypesChallengesCard } from "./types";

/** Shows a ChallengesCard for categorizing */
export function ChallengesCard(props: PropTypesChallengesCard) {
    const {
        bitmap,
        href,
        title,
        "title-text": titleT,
        summary,
        "summary-text": summaryT,
        hasFade = true,
        ...rest
    } = props;
    const className = getClassName(Rules.root, rest.className);

    return (
        <Component {...rest} name={NAME_CHALLENGES_CARD} tag="section" type={TYPE_CHALLENGES_CARD}>
            <div className={Rules.container}>
                <Card
                    {...rest}
                    bitmap={bitmap}
                    className={className}
                    hasFade={hasFade}
                    href={href}
                />
                <div className={Rules.text}>
                    {title ? (
                        <Text className={Rules.bottomText} preset="morelia" uuid={title} />
                    ) : (
                        <Text className={Rules.bottomText} preset="morelia">
                            {titleT}
                        </Text>
                    )}
                    {summary ? (
                        <Text className={Rules.bottomText} preset="merida" uuid={summary} />
                    ) : (
                        <Text className={Rules.bottomText} preset="merida">
                            {summaryT}
                        </Text>
                    )}
                </div>
            </div>
        </Component>
    );
}
ChallengesCard.defaultProps = DEF_CHALLENGES_CARD;
